import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import KbFoldersService from 'services/KbFolders.service';

const KbFolderDeletionModal = ({
  show,
  close,
  folderName,
  folderId,
  isSuccess
}) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();

  const [name, setName] = useState('');

  useEffect(() => {
    if (show) {
      setName('');
      console.log(folderId, folderName);
    }
  }, [show]);

  const handleDelete = async () => {
    const req = await KbFoldersService.delete(folderId);
    if (req.userMessage) {
      showErrorNotification(req.userMessage);
      return;
    }

    showSuccessNotification('Pasta excluída com sucesso');

    // Passar o ID da pasta excluída para o callback
    isSuccess(folderId);
    close();
  };

  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Exclusão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="w-100">
          <Flex>
            <div className="border-end border-2 border-warning d-flex align-items-center me-3 pe-3">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            </div>
            Todos os artigos presentes nessa pasta serão excluídos de forma
            permanente. Observe que esta ação é irreversível e não pode ser
            desfeita.
          </Flex>
        </Alert>

        <Form.Group>
          <Form.Label className="mt-3">
            Insira o nome da pasta para evitar exclusão acidental.
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={folderName || 'Nome do item'}
            required
            value={name}
            onChange={e => setName(e.target.value)}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={close}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={() => handleDelete(folderId)}
          disabled={name !== folderName}
        >
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default KbFolderDeletionModal;
